<template>
  <div class="">
    <nav class="list-group">
      <slot />
    </nav>
    <div
      v-if="hasPageMenu"
      :class="[
        'd-lg-none page-menu-container bg-menu',
        {
          'show': showPageMenu
        }
      ]"
    >
      <slot name="page"></slot>
    </div>
  </div>
</template>

<style lang="scss">
body, .slideout-container {
  width: 100%;
  height: 100%;
}

.slideout-menu {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 256px;
  min-height: 100vh;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  z-index: 0;
  display: none;
  padding-bottom: 100px;

  .page-menu-container {
    top: 0;
    bottom: 0;
    left: -256px;
    min-height: 100vh;
    position: fixed;
    width: 256px;
    transition: left 0.3s;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 100px;

    &.show {
      left: 0;
    }

    .list-group-item-mainmenu {

    }
  }

  &.wider {
    width: 320px;
    .page-menu-container {
      left: -320px;
      width: 320px;
    }
  }
}

.slideout-menu-left {
  left: 0;
}

.slideout-menu-right {
  right: 0;
}

.slideout-panel {
  position: relative;
  z-index: 1;
  /* will-change: transform; */
  /* background-color: #FFF; */
  min-height: 100vh;
  -webkit-overflow-scrolling: touch;
  /*
  -webkit-box-shadow: 2px 0px 10px 3px rgba(0,0,0,0.14);
  -moz-box-shadow: 2px 0px 10px 3px rgba(0,0,0,0.14);
  box-shadow: 2px 0px 10px 3px rgba(0,0,0,0.14);
   */
}

body.sidebar-open {
  .slideout-panel {
    position: fixed;
  }
}

.slideout-open,
.slideout-open body,
.slideout-open .slideout-container,
.slideout-open .slideout-panel {
  overflow: hidden !important;
}

.slideout-open .slideout-menu {
  display: block;
}

.slideout-menu .list-group-item {
  border: 0;
  border-radius: 0;
}

.wider {
  .slideout-menu .page-menu-container {
    left: -320px;
    width: 320px;
  }
}
</style>

<script>
import $ from 'jquery'
import Slideout from 'slideout'
import VueTypes from 'vue-types'

const $window = $(window)

export default {
  props: {
    id: VueTypes.string.isRequired,
    panel: VueTypes.string.def('#main'),
    tolerance: VueTypes.integer.def(70),
    side: VueTypes.string.def('left')
  },
  computed: {
    toggle () {
      return `[data-slideout="${this.id}"]`
    },
    hasPageMenu () {
      return !!this.$slots['page']
    }
  },
  data () {
    return {
      showPageMenu: true
    }
  },
  mounted () {
    let padding = 256
    if (this.$el.className.indexOf('wider') > -1) {
      padding = 320
    }

    $(() => {
      let $el = $(this.$el)
      let $panel = $(this.panel)
      let $body = $('body')

      $body.append($el)

      $el.parent().addClass('slideout-container')

      let slideout = new Slideout({
        panel: $panel[0],
        menu: $el[0],
        padding: padding,
        tolerance: this.tolerance,
        side: this.side,
        touch: false
      })

      $(this.toggle).click(() => {
        slideout.toggle()
        // TODO: if element has no href, it should be allowed to do default action
        return false
      })

      $panel.click(() => {
        if (slideout.isOpen()) {
          slideout.close()
          return false
        }
      })

      $el.find('a[href="#mainmenu"]').click(() => {
        this.showPageMenu = false
        return false
      })

      slideout.on('beforeopen', () => {
        $el.attr('style', '')
      })

      slideout.on('open', () => {
        if ($body.hasClass('collapsed-page-menu')) {
          this.showPageMenu = true
        }
      })

      slideout.on('close', () => {
        this.showPageMenu = true
        $el.attr('style', 'display:none')
      })

      $window.on('router.beforeEach', () => {
        slideout.close()
      })
    })
  }
}
</script>
